<script setup lang="ts">
import type { HybridlyFormData } from '@/@types/global';

import DangerDialog from '@/components/dialog/DangerDialog.vue';
import FormTextareaInput from '@/components/formTextareaInput/FormTextareaInput.vue';

defineProps<{
  form: HybridlyFormData<{
    rejected_reason: string;
  }>;
  isOpen: boolean;
}>();

const emit = defineEmits<{
  (e: 'onConfirm'): void;
  (e: 'onCancel'): void;
  (e: 'onClose'): void;
  (e: 'update:modelValue'): void;
}>();
</script>

<template>
  <DangerDialog
    title="Reject data request"
    message="If any information is missing, be sure to leave a message below or reach out to the student about how they can fix the request. Once rejected, the student will receive a new task prompting them to address the rejection."
    confirmButtonLabel="Confirm rejection"
    :isOpen="isOpen"
    :isLoading="form.processing"
    @onConfirm="emit('onConfirm')"
    @onCancel="emit('onCancel')"
    @onClose="emit('onClose')"
  >
    <template #body>
      <FormTextareaInput
        :error="form.errors.rejected_reason"
        :modelValue="form.fields.rejected_reason"
        isOptional
        label="Reason for rejection"
        name="rejected_reason"
        @update:modelValue="(value) => (form.fields.rejected_reason = String(value ?? ''))"
      />
    </template>
  </DangerDialog>
</template>
